import { render, staticRenderFns } from "./CommonLazyImg.vue?vue&type=template&id=79077e0c&"
import script from "./CommonLazyImg.vue?vue&type=script&lang=js&"
export * from "./CommonLazyImg.vue?vue&type=script&lang=js&"
import style0 from "./CommonLazyImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports